import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import WebIcon from "@mui/icons-material/Web";
import SoftwareIcon from "@mui/icons-material/Terminal";
import ComputerIcon from "@mui/icons-material/Computer";
import PlayIcon from "@mui/icons-material/PlayCircle";
import Pokemon from "../components/apps/pokemon/Pokemon";
import Game from "../components/apps/ticTacToe/Game";
import BlockGame from "../components/apps/blockGameFiles/BlockGame";
import PetClassifier from "../components/apps/petClassifier/PetClassifier";

var resumeData = {
  name: "Evan Blankenheim",
  title: "Software Engineer",
  email: "evblankenheim",

  socials: {
    LinkedIn: {
      link: "https://www.linkedin.com/in/evanblankenheim/",
      text: "evanblankenheim",
      icon: <LinkedInIcon />,
    },
    GitHub: {
      link: "https://github.com/eblankenheim",
      text: "eblankenheim",
      icon: <GitHubIcon />,
    },
  },

  about:
    "Passionate Software Engineer with 5+ years of experience, dedicated to developing using the newest tech in both work and personal projects. Skilled at creating innovative solutions, I thrive in a collaborative environment, applying my skills to design, code, and test cutting-edge applications within expansive microservice systems. \n\nBeyond work, I extend my coding skills to leisure activities, often delving into personal projects and assisting friends and family with their coding needs. This not only underscores my commitment to the craft but also showcases my ability to leverage the latest technology for creative and practical solutions in various contexts. Excellent communication and problem-solving skills, coupled with expertise in debugging and troubleshooting, allow me to navigate and overcome complex technical challenges seamlessly.",

  workExperience: [
    {
      title: "Northwestern Mutual",
      dateRange: "Software Engineer | 2022 - Present",
      description: [
        "Identified event issues and proposed infrastructure improvements, developing a queue setup for debugging and logging aligned with best practices for comprehensive analytics tracking, employing AWS SNS/SQS and Lambda serverless functions for efficient data logging and troubleshooting.",
        "Upgraded a key API module with the latest ESLint and Prettier, ensuring compatibility and conflict-free configurations through a comprehensive audit of existing configurations and plugin dependencies.",
        "Successfully onboarded services to a new cloud infrastructure, integrating shared CI templates and ensuring seamless deployment processes using GitLab CI/CD and Docker.",
      ],
    },
    {
      title: "Uline",
      dateRange: "Quality Assurance Analyst | 2021 - 2022",
      description: [
        "Executed various testing suites including integration, functional legacy system, regression, end-to-end component, and stress testing.",
        "Prepared test plans, defined acceptance criteria, and provided effort estimations with consideration for team capacity and adherence to Agile standards.",
        "Leveraged web services to ensure precise client-server data communication through endpoint integration, JSON, and API knowledge.",
      ],
    },
    {
      title: "College Pro",
      dateRange: "Job Site Manager | 2019 - 2020",
      description: [
        "Enhanced system processes by addressing bottlenecks, restrictions, and blockers while staying within budgetary constraints through collaborative efforts and effective solutions.",
        "Managed specific business operations with attention to detail, identifying and leveraging team strengths to maximize productivity.",
        "Accomplished all service requirements successfully while adhering to both budgetary and time constraints.",
      ],
    },
  ],

  education: [
    {
      title: "Genesis10 Dev10 Bootcamp",
      dateRange: "Full Stack Java Developer | 2020 - 2021",
      description:
        "Chosen as one of the fortunate few from a fiercely competitive applicant pool to participate in the highly regarded Dev10 Program, where only 5% of applicants earned a spot. Here, I underwent an immersive training experience in Full Stack Java development, equipping me with a deep and diverse skill set in software engineering.",
    },
    {
      title: "University of Wisconsin - Eau Claire",
      dateRange: "BBA - Information Systems | 2016 - 2020",
      description:
        "Former Leadership Community Member, actively engaged in addressing campus issues by identifying challenges and implementing effective solutions. Dedicated volunteer at local food pantries, supervising fellow students on various leadership projects, and offering tutoring services in Computer Science (CS) and Information Systems (IS) courses.",
    },
  ],
  services: [
    {
      title: "Software Engineer",
      description:
        "I have accumulated over four years of experience in coding, and my enthusiasm for it remains unwavering. While my primary focus lies in front-end application development, I also possess a level of proficiency in back-end development.",
      icon: <SoftwareIcon />,
    },
    {
      title: "PC Technician",
      description:
        "Over a decade ago, I embarked on my journey in PC Building, and my passion for hardware has only deepened since. My initial fascination was rooted in gaming, as a way to replace my 2005 console. Over the years, I have immersed myself in various projects for friends, family and clients.",
      icon: <ComputerIcon />,
    },
    {
      title: "Web Developer",
      description:
        "My exploration of web development initiated during my high school years and was subsequently nurtured through my college coursework. It has since evolved into a fulfilling endeavor, applying my knowledge to websites that cater to the needs of small business proprietors.",
      icon: <WebIcon />,
    },
  ],
  skills: [
    {
      title: "Front-end",
      description: [
        "React",
        "Typescript",
        "Javascript",
        "Bootstrap",
        "Material UI",
      ],
    },
    {
      title: "Back-end",
      description: ["NodeJS", "Kubernetes", "AWS", "Java", "ExpressJS"],
    },
    {
      title: "Database",
      description: ["Supabase", "GraphQL", "MySQL", "Dbeaver", "TablePlus"],
    },
    {
      title: "Source Control",
      description: ["Git", "GitLab", "Pylon", "Jira", "Microsoft Azure"],
    },
    {
      title: "Programs",
      description: ["VS Code", "IntelliJ", "Insomnia", "Docker", "Kibana"],
    },
  ],

  projects: [
    // ...other projects
    {
      tag: "PCs",
      image: `${require("../media/pcs/WestonsPC/Weston002.jpg")}`,
      images: [
        `${require("../media/pcs/WestonsPC/Weston001.jpg")}`,
        `${require("../media/pcs/WestonsPC/Weston002.jpg")}`,
      ],
      title: "Weston's PC",
      description: "",
      caption: "Ghost",
    },
    {
      tag: "Websites",
      image: `${require("../media/web/warnkeplumbing/warnkeplumbing_website.jpg")}`,
      images: [
        `${require("../media/web/warnkeplumbing/warnkeplumbing_website.jpg")}`,
      ],
      title: "Warnke Plumbing",
      description: `
          <h6>
              Built a website to showcase Warnke Plumbing's residential and commercial services, using <strong>React</strong> with <strong>Material-UI</strong> to deliver a professional and user-friendly experience.
            </h6>
            <h6>
              This project strengthened my skills in <strong>component-based architecture</strong>, <strong>responsive design</strong>, and <strong>service-oriented UI patterns</strong>. I implemented a multi-page layout with dedicated sections for services, contact information, and business hours, and architected <strong>client-side routing</strong> with <strong>React Router</strong> (nested routes + layout wrappers) for quick navigation.
            </h6>
            <h6>
              Integrated embedded <strong>Jobber scheduling & estimate forms</strong> directly into service and contact flows to streamline user experience, handling responsive iframe sizing, background loading, and mobile accessibility considerations.
            </h6>
            <h6>
              The site emphasizes <strong>clear service organization</strong>, <strong>intuitive component navigation</strong>, and <strong>mobile-optimized performance</strong>.
            </h6>
            <h6><strong>Tech Stack:</strong> React, Material-UI (MUI), Vite, AWS S3, CloudFront, Jobber Forms</h6>
          `,
      caption: "Website for a local plumbing company",
      links: [
        {
          link: "https://warnkeplumbing.com/",
          icon: <PlayIcon />,
          text: "Open",
        },
      ],
    },
    {
      tag: "Apps",
      image: `${require("../media/apps/petClassifier.jpg")}`,
      app: <PetClassifier />,
      title: "Pet Breed Classifier API",
      links: [
        {
          link: "https://github.com/eblankenheim/ai-pet-application",
          icon: <GitHubIcon />,
          text: "View Code",
        },
      ],
      description: `<h6>
            Deployed a <strong>FastAI-powered Python application</strong> on <strong>AWS EC2</strong>, managing multiple <strong>virtual environment setups</strong>, <strong>API hosting</strong>, and diagnosing complex runtime issues related to <strong>model serialization and cross-environment compatibility</strong>.
          </h6>
          <h6>
            My <strong>Flask API</strong> leverages a custom-trained, weighted model to differentiate between <strong>12 cat breeds</strong> and <strong>25 dog breeds</strong> across <strong>7,349 photos</strong>. After several hours of training, the app achieved <strong>over 90% accuracy</strong> in breed classification.
          </h6>
          <h6>
            This project required skills in <strong>cloud-based Python workflows</strong>, <strong>virtual environment management</strong>, <strong>machine learning</strong>, and <strong>API deployment</strong>. I also configured <strong>SSL/TLS</strong> for secure endpoints and worked hands-on with <strong>FastAI</strong>, <strong>PyTorch</strong>, <strong>Flask</strong>, and <strong>AWS Chalice</strong>.
          </h6>
          <h6>
            The process significantly improved my confidence with <strong>backend engineering</strong> and training <strong>machine learning models</strong>.
          </h6>
          <div style="margin-top:16px; text-align:left;">
            <strong>Tech Stack:</strong>
            <br />
            FastAI, PyTorch, Flask, AWS EC2, Nginx, Gunicorn, AWS Chalice
            <br />
            <br />
            <strong>Cat breeds:</strong>
            <ul style="columns:2; -webkit-columns:2; -moz-columns:2; text-align:left;">
              <li>Abyssinian</li>
              <li>Bengal</li>
              <li>Birman</li>
              <li>Bombay</li>
              <li>British Shorthair</li>
              <li>Egyptian Mau</li>
              <li>Maine Coon</li>
              <li>Persian</li>
              <li>Ragdoll</li>
              <li>Russian Blue</li>
              <li>Siamese</li>
              <li>Sphynx</li>
            </ul>
            <strong>Dog breeds:</strong>
            <ul style="columns:2; -webkit-columns:2; -moz-columns:2; text-align:left;">
              <li>American Bulldog</li>
              <li>American Pit Bull Terrier</li>
              <li>Basset Hound</li>
              <li>Beagle</li>
              <li>Boxer</li>
              <li>Chihuahua</li>
              <li>English Cocker Spaniel</li>
              <li>English Setter</li>
              <li>German Shorthaired</li>
              <li>Great Pyrenees</li>
              <li>Havanese</li>
              <li>Japanese Chin</li>
              <li>Keeshond</li>
              <li>Leonberger</li>
              <li>Miniature Pinscher</li>
              <li>Newfoundland</li>
              <li>Pomeranian</li>
              <li>Pug</li>
              <li>Samoyed</li>
              <li>Saint Bernard</li>
              <li>Scottish Terrier</li>
              <li>Shiba Inu</li>
              <li>Staffordshire Bull Terrier</li>
              <li>Wheaten Terrier</li>
              <li>Yorkshire Terrier</li>
            </ul>
          </div>`,
      caption: "Let AI guess your Cat/Dog's breed!",
    },
    {
      tag: "Websites",
      image: `${require("../media/web/idlesundays/idlesundays_website.JPG")}`,
      images: [
        `${require("../media/web/idlesundays/idlesundays_website.JPG")}`,
      ],
      title: "Idle Sundays",
      description: `<h6>
            Built a <strong>mobile-first website</strong> to promote seasonal car and bike meet-ups, using <strong>React</strong> with the <strong>Ionic framework</strong> to emulate a native app experience.
          </h6>
          <h6>
            This project sharpened my skills in <strong>mobile UI design</strong>, <strong>animation with Framer Motion</strong>, and <strong>client-side routing</strong>. I implemented a custom hero section with animated visuals, integrated event calendar support using <strong>React-Calendar</strong>, and deployed the site via <strong>AWS S3</strong> with automated cache invalidation through <strong>CloudFront</strong>.
          </h6>
          <h6>
            The site emphasizes a <strong>clean layout</strong>, <strong>smooth transitions</strong>, and <strong>responsive performance</strong> across devices.
          </h6>
          <h6><strong>Tech Stack:</strong> React, Ionic, Framer Motion, AWS S3, CloudFront, React Router</h6>
          `,
      caption: "Mobile Car Meet Website",
      links: [
        {
          link: "https://idlesundays.com/",
          icon: <PlayIcon />,
          text: "Open",
        },
        {
          link: "https://github.com/eblankenheim/idlesundays/blob/main/src/App.js",
          icon: <GitHubIcon />,
          text: "View Code",
        },
      ],
    },
    {
      tag: "Apps",
      app: <BlockGame />,
      image: `${require("../media/apps/buttonGame.png")}`,
      title: "Button Game",
      description: `<h6>
      Designed and developed a <strong>simple reflex game</strong> during one-on-one coding mentorship sessions with a middle school student. The project emphasized <strong>interactive UI logic</strong>, <strong>component-based design</strong>, and <strong>collaborative development</strong>.
    </h6>
    <h6>
      Players must turn all buttons "ON" before they reset, with difficulty settings that dynamically adjust reaction times. The app tracks <strong>total and average scores</strong>, and celebrates wins with <strong>confetti animations</strong>.
    </h6>
    <h6>
      This project introduced real-world <strong>React practices</strong> like state management with <code>useState</code> and <code>useEffect</code>, modular component reuse, and <strong>game logic synchronization</strong> based on user input and timers.
    </h6>
    <h6><strong>Tech Stack:</strong> React, CSS Modules, Functional Components, useState/useEffect</h6>`,
      caption: "Turn all buttons green before they flip back",
      links: [
        {
          link: "https://github.com/eblankenheim/buttonGame/blob/main/src/App.js",
          icon: <GitHubIcon />,
          text: "View Code",
        },
      ],
    },
    {
      tag: "PCs",
      image: `${require("../media/pcs/TrevsPC/Trev004.jpg")}`,
      images: [
        `${require("../media/pcs/TrevsPC/Trev001.jpg")}`,
        `${require("../media/pcs/TrevsPC/Trev002.jpg")}`,
        `${require("../media/pcs/TrevsPC/Trev003.jpg")}`,
        `${require("../media/pcs/TrevsPC/Trev004.jpg")}`,
      ],
      title: "Trev's PC",
      description: "",
      caption: "Spyro",
    },
    {
      tag: "Apps",
      app: <Pokemon />,
      image: `${require("../media/apps/pokemon.JPG")}`,
      title: "Pokemon Generator",
      description: `<h6>
          Developed a fun, self-directed app to explore <strong>Axios</strong> and deepen my understanding of working with public APIs.
        </h6>
        <h6>
          The app fetches data from the <strong>PokeAPI</strong>, dynamically selecting a random Pokémon using an integer index and rendering its name and image in real time.
        </h6>
        <h6>
          This project helped reinforce skills in <strong>API data extraction</strong>, <strong>dynamic rendering</strong>, and <strong>React state management</strong>.
        </h6>
        <h6><strong>Tech Stack:</strong> React, Axios, PokeAPI</h6>`,
      caption: "Discover a random Pokémon with every click",
      links: [
        {
          link: "https://github.com/eblankenheim/random-apps/blob/main/pokemon/Pokemon.js",
          icon: <GitHubIcon />,
          text: "View Code",
        },
      ],
    },
    {
      tag: "PCs",
      image: `${require("../media/pcs/DonsPC/Don001.jpg")}`,
      images: [
        `${require("../media/pcs/DonsPC/Don001.jpg")}`,
        `${require("../media/pcs/DonsPC/Don002.jpg")}`,
        `${require("../media/pcs/DonsPC/Don003.jpg")}`,
        `${require("../media/pcs/DonsPC/Don004.jpg")}`,
        `${require("../media/pcs/DonsPC/Don006.jpg")}`,
      ],
      title: "Don's PC",
      description: "",
      caption: "Blue Angels",
    },
    {
      tag: "Websites",
      image: `${require("../media/web/amalias/amalias_restaurant_website_before.jpg")}`,
      images: [
        `${require("../media/web/amalias/amalias_restaurant_website.jpg")}`,
        `${require("../media/web/amalias/amalias_restaurant_website_before.jpg")}`,
      ],
      title: "Amalia's Family Restaurant",
      description: `<h6>
          Created a custom website to revamp the online presence of Amalia's Family Restaurant, improving the user experience and accessibility compared to the previous outdated site.
        </h6>
        <h6>
          Emphasized a clean, responsive design that caters to mobile and desktop users, with a focus on <strong>whitespace management</strong> and intuitive navigation.
        </h6>
        <h6>
          Designed the site from the ground up using <strong>HTML</strong> and <strong>CSS</strong>, with a user-friendly layout that highlights the restaurant's diverse menu offerings and local ambiance.
        </h6>
        <h6><strong>Tech Stack:</strong> HTML, CSS, JavaScript</h6>`,
      caption: "Restaurant website project with a focus on user experience",
      links: [
        {
          link: "https://amaliasfamilyrestaurant.com/",
          icon: <PlayIcon />,
          text: "Open",
        },
        {
          link: "https://github.com/anonymousUser391/amaliasfamilyRestaurant/blob/main/index.html",
          icon: <GitHubIcon />,
          text: "View Code",
        },
      ],
    },
    {
      tag: "PCs",
      image: `${require("../media/pcs/AlexsPC/Alex003.jpg")}`,
      images: [
        `${require("../media/pcs/AlexsPC/Alex001.jpg")}`,
        `${require("../media/pcs/AlexsPC/Alex002.jpg")}`,
        `${require("../media/pcs/AlexsPC/Alex003.jpg")}`,
        `${require("../media/pcs/AlexsPC/Alex004.jpg")}`,
        `${require("../media/pcs/AlexsPC/Alex005.jpg")}`,
      ],
      title: "Alex's PC",
      description: "",
      caption: "Mini Me",
    },
    {
      tag: "Apps",
      app: <Game />,
      image: `${require("../media/apps/tictactoe.JPG")}`,
      title: "Tic-Tac-Toe",
      description: `<h6>
          Built a simple <strong>Tic-Tac-Toe game</strong> while following a foundational React tutorial to reinforce core concepts.
        </h6>
        <h6>
          Practiced managing <strong>component state</strong> with <strong>useState</strong>, conditionally rendering elements, creating reusable components, and implementing game logic using array manipulation.
        </h6>
        <h6>
          This project strengthened my understanding of <strong>event handling</strong>, <strong>JSX composition</strong>, and <strong>React component architecture</strong>.
        </h6>
        <h6><strong>Tech Stack:</strong> React</h6>`,
      caption: "Classic game built with React fundamentals",
      links: [
        {
          link: "https://github.com/eblankenheim/random-apps/blob/main/ticTacToe/Game.js",
          icon: <GitHubIcon />,
          text: "View Code",
        },
      ],
    },
    {
      tag: "Websites",
      image: `${require("../media/web/xtreme/xtreme_midwest_website_before.jpg")}`,
      images: [
        `${require("../media/web/xtreme/xtreme_midwest_website.jpg")}`,
        `${require("../media/web/xtreme/xtreme_midwest_website_before.jpg")}`,
      ],
      title: "Xtreme Enterprises",
      description: `<h6>
          Designed and developed a fully responsive <strong>e-commerce website</strong> for a Midwest-based retail business, focusing on layout, styling, branding, and mobile usability.
        </h6>
        <h6>
          Managed all aspects of the website including <strong>product gallery design</strong>, <strong>navigation structure</strong>, and <strong>client communication</strong> throughout the process.
        </h6>
        <h6>
          Overcame key challenges in <strong>color palette cohesion</strong> and <strong>functionality optimization</strong> to align the interface with the company's identity and improve user experience.
        </h6>
        <h6><strong>Tech Stack:</strong> HTML, CSS, JavaScript</h6>`,
      caption: "E-commerce website for Midwest product distributor",
      links: [
        {
          link: "https://xtrememidwest.com/",
          icon: <PlayIcon />,
          text: "Open",
        },
        {
          link: "https://github.com/xtrememidwest/xtrememidwest/blob/main/index.html",
          icon: <GitHubIcon />,
          text: "View Code",
        },
      ],
    },
    {
      tag: "PCs",
      image: `${require("../media/pcs/EvansPC/Evan006.jpg")}`,
      images: [
        `${require("../media/pcs/EvansPC/Evan001.jpg")}`,
        `${require("../media/pcs/EvansPC/Evan002.jpg")}`,
        `${require("../media/pcs/EvansPC/Evan003.jpg")}`,
        `${require("../media/pcs/EvansPC/Evan004.jpg")}`,
        `${require("../media/pcs/EvansPC/Evan005.jpg")}`,
        `${require("../media/pcs/EvansPC/Evan006.jpg")}`,
      ],
      title: "Evan's PC",
      description: "",
      caption: "Frankenstein",
    },
    {
      tag: "PCs",
      image: `${require("../media/pcs/MattsPC/Matt001.jpg")}`,
      images: [`${require("../media/pcs/MattsPC/Matt001.jpg")}`],
      title: "Matt's PC",
      description: "",
      caption: "Silver Surfer",
    },
  ],
};

export default resumeData;
